import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.color};
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  text-align: center;
`;
